import dayjs from '@/dayjs'

import BaseNotification from '../BaseNotification'

export default class DepositRequiredToSecureBooking extends BaseNotification {
  get processedMessage(): string {
    return super.processedMessage
      .replace('{payDepositLink}', this.payDepositLink)
      .replace(
        '{paymentDueDateTime}',
        dayjs
          .utc(this.notification.data.paymentDueDateTime)
          .format('DD/MM/YYYY'),
      )
  }

  get payDepositLink(): string {
    return this.notification.paymentAllowed
      ? `
          <router-link
            :to="{
              name: 'makePayment',
              query: { bookingId: '${this.notification.enquiryId}' },
            }"
          >
            Pay deposit
          </router-link>.
        `
      : ''
  }

  get iconClass(): string {
    return 'sc-icon-money-box'
  }
}
